const f = {
  color: {
    background: "#ffffffff",
    outline: "#304ddbff",
    subtitle: "#556575ff",
    body: "#253642ff",
    blockquote: {
      text: "#556575ff",
      border: "#c8d3deff"
    },
    inlineCode: {
      text: "#e54a32ff",
      background: "#f1f3f5ff"
    },
    pre: {
      text: "#1d2b36ff",
      border: "#c8d3deff",
      background: "#f9fafaff"
    },
    link: {
      base: "#304ddbff",
      hover: "#263aadff",
      active: "#1c2674ff"
    },
    actionButton: "#abb9c7ff",
    strong: "#1d2b36ff",
    articleCard: {
      title: "#314351ff",
      meta: "#556575ff",
      content: "#556575ff"
    },
    surveyNps: "#556575ff",
    survey: {
      feedback: "#405261ff",
      spinner: "#405261ff",
      confirmation: "#405261ff",
      multiple: "#253642ff"
    },
    modal: {
      title: "#253642ff",
      label: "#556575ff",
      body: "#253642ff",
      closeButton: "#7e8e9eff",
      closeButtonHover: "#314351ff"
    },
    nps: {
      poweredby: "#556575ff",
      question: "#253642ff",
      feedback: "#253642ff"
    }
  }
};
export {
  f as messageCard
};
